import { render, staticRenderFns } from "./SelectDistrictComponent.vue?vue&type=template&id=fac6fd3c&scoped=true&"
import script from "./SelectDistrictComponent.vue?vue&type=script&lang=js&"
export * from "./SelectDistrictComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac6fd3c",
  null
  
)

export default component.exports